export class Project {
  Name: string;
  ProjectId: string;
  Id: number;
  ObsId: number;
  InstanceId?: string;
}
